export interface NavigationItem {
  path: string;
  label: string;
  title: string;
  pattern?: RegExp;
}

export const navigationConfig: NavigationItem[] = [
  { path: '/form', label: 'form', title: 'formTitle' },
  { path: '/settings', label: 'settings', title: 'settingsTitle' },
  { path: '/dashboard', label: 'dashboard', title: 'dashboardTitle' },
  { path: '/diagrams', label: 'diagrams', title: 'diagrams' },
  { path: '/translations', label: 'translations', title: 'translations' },
  {
    path: '/roles/:id/edit',
    label: 'editRole',
    title: 'editRole',
    pattern: /^\/roles\/\d+\/edit$/
  },
];